import { apiSlice } from "../api/apiSlice";
import paramConfig from "../../config/paramConfig";
import getPaginationInfo from "../../utils/getPaginationInfo";

export const assessmentsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssessments: builder.query({
      query: ({ id, page = 1, pageSize = 100 }) =>
        `/organisations/${id}/assessments?${paramConfig.PAGE_NUMBER}=${page}&${paramConfig.PAGE_SIZE}=${pageSize}`,
      transformResponse: (response, meta) => {
        const pagination = getPaginationInfo(meta);
        return { response, pagination };
      },
      providesTags: (result, error, arg) => [
        { type: "Assessment", id: arg?.id },
        { type: "AssessmentsPending", id: arg?.page },
        { type: "AssessmentsPending", id: arg?.pageSize },
      ],
    }),
    getAssessmentsPending: builder.query({
      query: ({ report = false, page = 1, pageSize = 100 }) =>
        `/assessments?${paramConfig.REPORT}=${report}&${paramConfig.PAGE_NUMBER}=${page}&${paramConfig.PAGE_SIZE}=${pageSize}`,
      transformResponse: (response, meta) => {
        const pagination = getPaginationInfo(meta);
        return { response, pagination };
      },
      providesTags: (result, error, arg) => [
        { type: "AssessmentsPending" },
        { type: "AssessmentsPending", id: arg?.page },
        { type: "AssessmentsPending", id: arg?.pageSize },
      ],
    }),
    getAssessmentsFinished: builder.query({
      query: ({ report = true, page = 1, pageSize = 100 }) =>
        `/assessments?${paramConfig.REPORT}=${report}&${paramConfig.PAGE_NUMBER}=${page}&${paramConfig.PAGE_SIZE}=${pageSize}`,
      transformResponse: (response, meta) => {
        const pagination = getPaginationInfo(meta);
        return { response, pagination };
      },
      providesTags: (result, error, arg) => [
        { type: "AssessmentsFinished" },
        { type: "AssessmentsFinished", id: arg?.page },
        { type: "AssessmentsFinished", id: arg?.pageSize },
      ],
    }),
    getAnalysisProfiles: builder.query({
      query: () => `/analysis_profiles`,
      providesTags: () => [{ type: "AnalysisProfiles" }],
    }),
    getAssessment: builder.query({
      query: ({ organisationId, assessmentId }) => {
        if (organisationId == null) {
          return `/assessments/${assessmentId}`;
        }
        return `/organisations/${organisationId}/assessments/${assessmentId}`;
      },
      providesTags: (result, error, arg) => [
        {
          type: "Assessment",
          id: `${arg?.organisationId ? arg?.organisationId + "-" : ""}${
            arg?.assessmentId
          }`,
        },
      ],
    }),
    postAssessment: builder.mutation({
      query: ({ params, body }) => {
        return {
          url: `/organisations/${params?.id}/assessments`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Assessment" }],
    }),
  }),
});

export const {
  useGetAnalysisProfilesQuery,
  useGetAssessmentsPendingQuery,
  useGetAssessmentsFinishedQuery,
  useGetAssessmentsQuery,
  useGetAssessmentQuery,
  usePostAssessmentMutation,
} = assessmentsSlice;
